export enum PaymentType {
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    DEBIT_CARD = 'DEBIT_CARD'
}



// WEBPACK FOOTER //
// ./src/types/enums/PaymentType.ts